define('lq/clipboard',[
    'jquery'
], function ($) {
    'use strict';
    
    return {

        copy: function(content) {
            var $textarea = $('<textarea />')
                .val(content)
                .width(0)
                .height(0)
                .appendTo('body')
                .trigger('select');

            document.execCommand('copy');

            $textarea.remove();
        }

    };
});
